import React from 'react';
import { useI18n } from '../i18n/i18nContext';
import ContentPageRenderer from '../components/ContentPageRenderer';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import SEO from '../components/SEO';

const ContactPage: React.FC = () => {
  const { t } = useI18n();
  useDocumentTitle(t.pageTitles.contact);

  return (
    <div className="bg-white py-12">
      <SEO description={t.seo.contactDescription} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">{t.about.title}</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="mb-8">
              <ContentPageRenderer slug="about-page-content" />
            </div>
          </div>

          <div className="h-full max-h-[600px] bg-gray-100 rounded-xl overflow-hidden shadow-md ring-1 ring-black/5">
            <img
              src="/images/fire-and-ice-building.png"
              alt="Fire & Ice Building"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
